import { PALETTE } from "../lib/categories";

export const Marquee = ({ items }) => {
  const content = (
    <div className="marquee__track" aria-hidden="true">
      {items.map((t, i) => (
        <span
          key={i}
          className="font-display text-4xl font-bold uppercase tracking-tight text-[var(--text)] sm:text-6xl"
        >
          {t}
          <span className="mx-8" style={{ color: PALETTE[i % PALETTE.length] }}>
            ✦
          </span>
        </span>
      ))}
    </div>
  );
  return (
    <div className="marquee border-y border-[var(--border)] py-6" data-testid="editorial-marquee">
      {content}
      {content}
    </div>
  );
};
